// removed by extract-text-webpack-plugin
module.exports = {"root":"_34J1pqH"};


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/SearchResultPage/components/Leaderboard/Leaderboard.less
 ** module id = 860
 ** module chunks = 0
 **/